import {
  createRouter as createVueRouter,
  createWebHistory,
} from 'vue-router'
import type { RouteRecordRaw, Router } from 'vue-router'

import routes from './routes/index.ts'
import { registerGuards } from './guards/index.ts'
import { baseUrl } from './location-params.ts'
import { setMeta } from '@/router/default-routes-meta.ts'

// HACK-VUE3
// It is designed for vue3 purposes. Just in case, we want to test this logic on vue2 only on development stage.
setMeta(routes)

export function createRouter (): Router {
  const router = createVueRouter({
    history: createWebHistory(baseUrl),
    routes: routes as RouteRecordRaw[],
    scrollBehavior () {
      return { top: 0 }
    },
  })

  registerGuards(router)

  return router
}

